import React from 'react';
import { Col } from '@amzn/atoz-web/Col';
import { Row } from '@amzn/atoz-web/Row';
import { View } from '@amzn/atoz-web/View';
import { Card } from '@amzn/atoz-web/Card';
import { StopPropagationContainer } from '../shared';
import { OpportunityStatuses } from '../OpportunityFlowModal/OpportunityStatuses';
import { getOpportunityDetails } from './getOpportunityDetails';
export var OpportunityCard = function (_a) {
    var shiftOpportunity = _a.shiftOpportunity, addShiftButton = _a.addShiftButton, viewOpportunityDetailsButton = _a.viewOpportunityDetailsButton, shiftInfo = _a.shiftInfo, payLabel = _a.payLabel;
    var _b = getOpportunityDetails(shiftOpportunity), isEligible = _b.isEligible, unclaimableReasonCodes = _b.unclaimableReasonCodes, hasDropPenalty = _b.hasDropPenalty, isUndroppable = _b.isUndroppable, dropDeadline = _b.dropDeadline, locksBeforeStart = _b.locksBeforeStart;
    return (React.createElement(View, { role: "listitem" },
        React.createElement(Card, { "data-testid": "OpportunityCard-".concat(shiftOpportunity.shift.id), flexDirection: "column" },
            React.createElement(Col, { gridGap: "S200" },
                React.createElement(Row, { justifyContent: "space-between" },
                    shiftInfo,
                    payLabel),
                React.createElement(OpportunityStatuses, { ineligibilityReasons: unclaimableReasonCodes, hasDropPenalty: hasDropPenalty, isUndroppable: isUndroppable, dropDeadline: dropDeadline, locksBeforeStart: locksBeforeStart })),
            React.createElement(Row, { justifyContent: "flex-end", gridGap: "S200" },
                viewOpportunityDetailsButton,
                isEligible && (React.createElement(StopPropagationContainer, null, addShiftButton))))));
};
